export default "__VITE_ASSET__6mhU9aUT__"